import React from 'react';


const IconMainMenu: React.FC = () => (
    <svg className="icon-main-menu" width="12" height="12" viewBox="0 0 12 12" fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd"
            d="M0.121094 0.166504H5.37109V3.95817H0.121094L0.121094 0.166504ZM1.28776
              1.33317V2.7915H4.20443V1.33317H1.28776ZM0.121094 5.4165H5.37109V11.8332H0.121094L0.121094 5.4165ZM1.28776
              6.58317V10.6665H4.20443V6.58317H1.28776ZM11.7878 0.166504H6.53776V5.4165H11.7878V0.166504ZM7.70443
              4.24984V1.33317H10.6211V4.24984H7.70443ZM11.2044 7.1665H7.12109V11.2498H11.2044V7.1665Z"
        />
    </svg>
);

export default IconMainMenu;